import { FunctionComponent, useState, useEffect } from 'react';
import Fade from '@material-ui/core/Fade';
import { RenderHtml } from '../render-html/render-html';
import { useStyles } from './fold-out-box.styles';

type FoldOutContentProps = {
    contentHtml: string;
    visible: boolean;
};

const FoldOutContent: FunctionComponent<FoldOutContentProps> = (props): JSX.Element => {
    const [visible, setVisible] = useState<boolean>(props.visible);
    const classes = useStyles();

    useEffect(() => {
        setVisible(props.visible);
    }, [props.visible]);

    return (
        <Fade in={visible} unmountOnExit={true}>
            <div className={classes.detailContainer}>
                <RenderHtml html={props.contentHtml} />
            </div>
        </Fade>
    );
};

type FoldOutBoxProps = {
    headerHtml: string;
    contentHtml: string;
};

const FoldOutBox: FunctionComponent<FoldOutBoxProps> = (props): JSX.Element => {
    const classes = useStyles();
    const [contentVisible, setContentVisible] = useState(false);

    const toggleContent = () => {
        setContentVisible((prev) => !prev);
    };

    return (
        <div className={classes.main}>
            <div className={classes.header} onClick={toggleContent} role={'button'}>
                <RenderHtml html={props.headerHtml} />
                <Fade in={!contentVisible}>
                    <flos-icon shape={'arrow'} size="20" class={classes.downIcon} />
                </Fade>
                <Fade in={contentVisible}>
                    <flos-icon shape={'plus'} size="20" class={classes.closeIcon} />
                </Fade>
            </div>
            <FoldOutContent contentHtml={props.contentHtml} visible={contentVisible} />
        </div>
    );
};

export { FoldOutBox };
export type { FoldOutBoxProps };
